import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import CalendlyAuthCallbackPage from './CalendlyAuthCallbackPage.js';

export default WithGASetup(CalendlyAuthCallbackPage, AuthContext);
